'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiNotes = function TiNotes(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.4 6.8c-0.2-0.2-0.4-0.3-0.7-0.2l-18.3 2c-0.4 0.1-0.7 0.5-0.7 0.9v17.2c-2.8 0-5 1.8-5 4.1s2.2 4.2 5 4.2 5-1.9 5-4.2v-12.7l10-1v6.2c-2.8 0-5 1.9-5 4.2s2.2 4.2 5 4.2 5-1.9 5-4.2v-20.1c0-0.3-0.1-0.5-0.3-0.6z' })
        )
    );
};

exports.default = TiNotes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/notes.js
// module id = 3677
// module chunks = 0